import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Confirm from "../Registration/Confirm";
import {
  postPasswordResetCode,
  postPasswordResetForm,
} from "../../../services/auth/passwordService";
import TokenService from "../../../services/token.service.js";
import bilAPI from "../../../services/api";
import { UserContext } from "../../../utils/contexts/UserContext";
import ResetForm from "./ResetForm";

export default function ResetPassword() {
  const [step, setStep] = useState(1);
  const [t] = useTranslation();

  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState(null);
  const [username, setUsername] = useState(null);
  const [error, setError] = useState(null);

  const onSubmitRegistration = async (data) => {
    setError(null);
    setLoading(true);
    setPassword(data.password);
    setUsername(data.iin);
    await postPasswordResetForm({ iin: data.iin })
      .then((res) => {
        setStep(2);
      })
      .catch((err) => {
        setError(err.response.data.detail);
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAccountInfo = async () => {
    try {
      const response = await bilAPI.get("/auth/my_account/", {});

      await setUser(response.data);
    } catch (err) {
      console.error("Account info error:", err);
      setError(
        err.response?.data?.detail || t("auth.failed_to_get_account_info")
      );
      // If account info fails, remove tokens
      await TokenService.removeLocalTokens();
    }
  };

  const onSubmitConfirm = async (data) => {
    const code = Object.values(data).join("");
    setLoading(true);
    setError(null);
    postPasswordResetCode({ code, password })
      .then(async (res) => {
        console.log(res);
        await TokenService.updateLocalAccessToken(res.access);
        if (res.refresh) {
          await TokenService.updateLocalRefreshToken(res.refresh);
        }

        // Set API header
        bilAPI.defaults.headers["Authorization"] = "Bearer " + res.access;

        // Get account info and navigate
        await getAccountInfo();
      })
      .catch((err) => {
        console.log(err.response.data);
        if (err.response.data.code === 1) {
          setError(t("signup.code_is_invalid_or_expired"));
        } else if (err.response.data.code === 4) {
          setError(t("signup.new_password_same_to_current"));
        } else {
          setError(err.response.data.detail);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const links = [
    {
      text: t("signup.already_have_account"),
      onClick: () => navigate("/login"),
    },
    {
      text: t("signup.create_account"),
      onClick: () => navigate("/registration"),
    },
  ];

  return (
    <div>
      {step === 1 && (
        <ResetForm
          onSubmit={onSubmitRegistration}
          error={error}
          loading={loading}
          links={links}
        />
      )}
      {step === 2 && (
        <Confirm
          onSubmit={onSubmitConfirm}
          error={error}
          loading={loading}
          links={links}
          confirmText={t("buttons.next")}
          username={username}
          purpose={1}
        />
      )}
    </div>
  );
}
